(function () {
  function buildStars(rating) {
    var floor = Math.floor(rating);
    var dec = rating - floor;
    var rd = 0;
    if (dec >= 0.3 && dec <= 0.7) rd = 0.5;
    else if (dec > 0.7) rd = 1;
    return '<div class="rating" role="img" aria-label="' + rating + ' out of 5 stars">'
      + '<span class="rating-star" style="--rating:' + floor + ';--rating-max:5;--rating-decimal:' + rd + ';"></span>'
      + '</div>';
  }

  function fmt(n) {
    var v = Number(n);
    return isNaN(v) ? '0' : v.toLocaleString('en-US');
  }

  function render(el, data) {
    var rating = Number(data.rating);
    if (!rating || isNaN(rating)) { el.remove(); return; }
    var layout = el.getAttribute('data-layout') || 'card';
    var stars = buildStars(rating);
    if (layout === 'full') {
      el.innerHTML = '<span class="goodreads-rating__label">Goodreads:</span>'
        + stars
        + '<span class="goodreads-rating__meta">' + rating.toFixed(2)
        + ' · ' + fmt(data.ratings_count) + ' ratings'
        + ' · ' + fmt(data.reviews_count) + ' reviews</span>';
    } else {
      el.innerHTML = stars
        + '<span class="goodreads-rating__text">' + rating.toFixed(2) + '/5</span>';
    }
    el.classList.remove('goodreads-rating--pending');
  }

  var pending = document.querySelectorAll('[data-goodreads]:not([data-goodreads-done])');
  Array.prototype.forEach.call(pending, function (el) {
    el.setAttribute('data-goodreads-done', '1');
    var isbn = el.getAttribute('data-isbn');
    var productId = el.getAttribute('data-product-id');
    if (!isbn) { el.remove(); return; }
    fetch('/apps/baloo/goodreads/sync', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ isbn: isbn, product_id: productId })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && !data.error) render(el, data);
        else el.remove();
      })
      .catch(function () { el.remove(); });
  });
})();
